import { ChangeDetectionStrategy, Component, ElementRef, inject, output } from '@angular/core';
import { ActivitySectionDirective, SpecialsService, UserActivityClickTrackingDirective } from '@core';
import { PageHeaderBackSwipeConfig, PageHeaderComponent } from '@app/components/page-header/page-header.component';
import { SwiperContainerComponent } from '@core/lib/components/swiper/swiper-container.component';
import { SwiperSlideComponent } from '@core/lib/components/swiper/swiper-slide.component';
import { map } from 'rxjs/operators';
import { toSignal } from '@angular/core/rxjs-interop';
import { LoadingComponent } from '@app/components/loading/loading.component';
import { SwiperVideoControlDirective } from '@core/lib/components/swiper/swiper-video-control.directive';

@Component({
  selector: 'app-more-shop-beer',
  templateUrl: './shop-beer.component.html',
  styleUrl: './shop-beer.component.scss',
  imports: [
    ActivitySectionDirective,
    PageHeaderComponent,
    UserActivityClickTrackingDirective,
    SwiperContainerComponent,
    SwiperSlideComponent,
    LoadingComponent,
    SwiperVideoControlDirective,
  ],
  host: {
    class: 'page',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShopBeerComponent {

  private readonly specialsService = inject(SpecialsService);
  private readonly elementRef = inject<ElementRef<HTMLElement>>(ElementRef);

  protected readonly backSwipeConfig: PageHeaderBackSwipeConfig = {
    element: this.elementRef.nativeElement,
  };

  private readonly beerSpecials$ = this.specialsService.specials$.pipe(
    map((specials) => {
      return specials?.filter(special => special.name.startsWith('[shop-bear]'));
    }),
  );

  public readonly beerSpecials = toSignal(this.beerSpecials$);

  public readonly loading = toSignal(this.specialsService.loading$, {
    initialValue: true,
  });

  public readonly back = output();


}
